import { AuthorizationService } from "../../../../../lib/auth.service";
import { IHttpClient } from "../../../../../lib/http";
import { Condition } from "../domain/Condition.entity";
import { ConditionDto } from "./Condition.dto";
import { ConditionMapper } from "./condition.mapper";

export interface ConditionRepository {
  getAll(propertyTicker: string): Promise<Condition[]>;
}

export class ConditionApiRepository implements ConditionRepository {
  constructor(
    private readonly httpClient: IHttpClient,
    private readonly authorizationService: AuthorizationService
  ) {}

  async getAll(propertyTicker: string): Promise<Condition[]> {
    const token = await this.authorizationService.getRptToken(propertyTicker);
    const response = await this.httpClient.get<ConditionDto[]>(
      `/api/backoffice/${propertyTicker}/conditions`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-property": propertyTicker,
        },
      }
    );

    return response.map(conditionDto => ConditionMapper.toDomain(conditionDto));
  }
}
